var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "overlay popup-overlay",
      class: { active: this.$root.popup_active },
    },
    [
      _c(
        "div",
        {
          staticClass: "close-btn toggle-popup-scroll",
          on: { click: this.$root.toggle_popup },
        },
        [_c("span")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row", staticStyle: { "min-height": "700px" } },
          [
            _c("div", { staticClass: "col-12 col-lg-6" }, [
              _c("h2", [
                _vm._v(_vm._s(_vm.localStrings["We are both players."])),
                _c("br"),
                _vm._v(_vm._s(_vm.localStrings["Let’s team up."])),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.localStrings[
                      "Enetpulse remains the most trusted source of live sports scores, facts, and statistics. Our live score feeds from 80+ sports keeps the sporting world alert 24/7."
                    ]
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-lg-5 offset-lg-1" }, [
              _c("div", {
                staticClass: "row header-form",
                domProps: { innerHTML: _vm._s(_vm.contact_form) },
              }),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }